import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import howto from '../img/howto.jpg';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const CategorySelector = ({ selectedCategory }) => {
    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${API_URL}/api/categories`);
                if (!response.ok) throw new Error("Error al obtener las categorías");
                const data = await response.json();

                const formattedCategories = data.map((category) => ({
                    id: category.id,
                    icon: category.icon || "bi-list-check",
                    label: category.name,
                }));
                setCategories(formattedCategories);
            } catch (error) {
                console.error("Error cargando categorías:", error);
            }
        };

        fetchCategories();
    }, []);

    const handleCategoryClick = (category) => {
        const encodedCategory = encodeURIComponent(category);
        navigate(`/servicelink?service=${encodedCategory}`);
    };

    return (
        <div>
            {/* Fila de Categorías con ancho limitado */}
            <Container className="text-center mb-5">
                <Row>
                    {categories.length > 0 ? (
                        categories.map((category) => (
                            <Col xs={6} sm={6} md={4} lg={3} key={category.id} className="category-item-col mb-4">
                                <div
                                    className={`category-item ${selectedCategory === category.label ? "selected" : ""}`}
                                    onClick={() => handleCategoryClick(category.id)}
                                    style={{
                                        cursor: "pointer",
                                        border: selectedCategory === category.label ? "2px solid #007bff" : "none",
                                        padding: "10px",
                                        borderRadius: "10px",
                                        transition: "0.3s ease",
                                        textAlign: "center",
                                        height: "100%",
                                    }}
                                >
                                    <i className={`bi ${category.icon} category-icon`} id={category.id} name={category.id} style={{ fontSize: "30px" }}></i>
                                    <span className="category-label" style={{ fontSize: "14px", display: "block" }}>{category.label}</span>
                                </div>
                            </Col>
                        ))
                    ) : (
                        <p>Cargando categorías...</p>
                    )}
                </Row>
            </Container>

            {/* Sección "Cómo funciona" con mayor ancho */}
            <Container fluid className="mt-4">
                <Row className="justify-content-center align-items-center">
                    {/* Card para el texto */}
                    <Col md={6}>
                        <Card className="shadow-lg p-4 border-0" style={{ backgroundColor: '#f9f9f9', borderRadius: '10px' }}>
                            <Card.Body>
                                <h4 className="fw-bold text-dark mb-4 text-center">Cómo funciona</h4>
                                <div className="d-flex flex-column align-items-center gap-3">
                                    {/* Paso 1 */}
                                    <div className="d-flex flex-column align-items-center">
                                        <div className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: '40px', height: '40px', backgroundColor: '#d9d6fe', color: '#3f3d56', fontWeight: 'bold', fontSize: '16px' }}>
                                            1
                                        </div>
                                        <p className="text-muted text-center fs-6 mt-2">Elige un servicio.</p>
                                    </div>
                                    {/* Paso 2 */}
                                    <div className="d-flex flex-column align-items-center">
                                        <div className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: '40px', height: '40px', backgroundColor: '#fef9c3', color: '#6d4c41', fontWeight: 'bold', fontSize: '16px' }}>
                                            2
                                        </div>
                                        <p className="text-muted text-center fs-6 mt-2">Programa una tarea.</p>
                                    </div>
                                    {/* Paso 3 */}
                                    <div className="d-flex flex-column align-items-center">
                                        <div className="rounded-circle d-flex align-items-center justify-content-center"
                                            style={{ width: '40px', height: '40px', backgroundColor: '#dcfce7', color: '#065f46', fontWeight: 'bold', fontSize: '16px' }}>
                                            3
                                        </div>
                                        <p className="text-muted text-center fs-6 mt-2">Chatea, paga, da propinas y opina, todo en un solo lugar.</p>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>


                    </Col>

                    {/* Card para la imagen */}
                    <Col md={6}>
                        <Card className="shadow-lg p-4 border-0 d-flex align-items-center justify-content-center"
                            style={{ backgroundColor: '#ffffff', borderRadius: '10px' }}>
                            <img src={howto} alt="HowTo" className="img-fluid rounded shadow"
                                style={{ maxWidth: '100%', height: 'auto', objectFit: 'cover', borderRadius: '10px' }} />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );


};

export default CategorySelector;
